import React from "react";

import {CircularProgress} from "@mui/joy";

// components
import AttachmentsTab from "../Attachment/AttachmentsTab";
import WikiPageTab from "./WikiPageTab";
import WikiPageDetailHeader from "./WikiPageDetailHeader";
import CommonDetail from "../Common/CommonDetail";
import withRouter from "../../utils/withRouter";
import BaseApi from "../../utils/BaseApi";
import EditorTab from "./EditorTab";
import retrievePermission from "../../utils/retrievePermission";
import UserSubscriberContext from "../../context/UserSubscriberContext";

// icons
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AttachFileIcon from "@mui/icons-material/AttachFile";


class WikiPageDetail extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            wikiPage: null,
            updatePermission: 0,
        };
    }

    async componentDidMount() {
        await this.retrieveWikiPage();
        await this.retrieveUpdatePermission();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveWikiPage();
        }
    }

    async retrieveUpdatePermission() {
        let p = await retrievePermission(
            'WikiPageViewSet',
            'partial_update',
            this.context.subscriberObject
        );
        this.setState(
            {
                updatePermission: p
            }
        );
    }

    async retrieveWikiPage() {
        this.setState(
            {
                wikiPage: null
            }
        );
        const url = `wiki_page/${this.props.params.wikiPageId}`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        this.setState(
            {
                wikiPage: response.data
            }
        );
    }

    render() {
        if (!this.state.wikiPage) {
            return (<CircularProgress/>)
        }
        return (
            <CommonDetail
                appName={'WikiPage'}
                appId={this.state.wikiPage.id}
                header={{
                    component: WikiPageDetailHeader,
                    componentProps: {
                        wikiPage: this.state.wikiPage
                    },
                    leftOverflow: {
                        icon: null,
                        title: 'Wiki',
                        color: 'primary'
                    },
                }}
                defaultTabValue={'info'}
                tabComponents={[
                    {
                        title: 'Информация',
                        value: 'info',
                        icon: AccountTreeIcon,
                        component: <WikiPageTab
                            wikiPage={this.state.wikiPage}
                            callBack={this.retrieveWikiPage.bind(this)}
                        />,
                    },
                    {
                        title: 'Вложения',
                        value: 'attachment',
                        icon: AttachFileIcon,
                        component: <AttachmentsTab
                            appId={this.state.wikiPage.id}
                            appName={'WikiPage'}
                        />
                    },
                    ...this.state.updatePermission?[
                        {
                            title: 'Редактирование',
                            value: 'edit',
                            icon: AccountTreeIcon,
                            component: <EditorTab
                                wikiPage={this.state.wikiPage}
                                callBack={this.retrieveWikiPage.bind(this)}
                            />,
                        },
                    ]:[],
                ]}
            />
        )
    }
}

export default withRouter(WikiPageDetail);
